var _ellipse, _ellipse2, _ellipse3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTaskMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 5,
    viewBox: "0 0 18 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.29964,
    cy: 2.23,
    rx: 2.23,
    ry: 2.29997,
    transform: "rotate(90 9.29964 2.23)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.2996,
    cy: 2.23,
    rx: 2.23,
    ry: 2.29997,
    transform: "rotate(90 15.2996 2.23)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.29964,
    cy: 2.23,
    rx: 2.23,
    ry: 2.29997,
    transform: "rotate(90 3.29964 2.23)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskMenuIcon);
export default __webpack_public_path__ + "static/media/task-menu-icon.af761b0b934cfe5b19a34254ac7ec22a.svg";
export { ForwardRef as ReactComponent };